type Environment = "production" | "preview" | "development";

interface Config {
  baseUrl: string;
  domain: string;
  application: string;
  bucket: string;
  supabaseUrl: string;
  supabaseAnonKey: string;
  supabaseServiceRoleKey: string | undefined;
  sentryDsnUrl: string | undefined;
  sentryEnabled: boolean;
  branch: string;
  environment: Environment;
  registrationsClosed: boolean;
  demoSongId: string;

  resendApiKey: string | undefined;
  posthogKey: string;
  posthogHost: string;
  posthogEnabled: boolean;
}

const getConfig = (): Config => {
  return {
    baseUrl: process.env.BASE_URL!,
    domain: process.env.DOMAIN!,
    application: process.env.APPLICATION!,
    bucket: process.env.NEXT_PUBLIC_BUCKET!,
    supabaseUrl: process.env.NEXT_PUBLIC_SUPABASE_URL!,
    supabaseAnonKey: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    supabaseServiceRoleKey: process.env.SUPABASE_SERVICE_ROLE_KEY,
    resendApiKey: process.env.RESEND_API_KEY,
    sentryDsnUrl: process.env.SENTRY_DSN_URL,
    sentryEnabled: process.env.SENTRY_ENABLED === "true",
    branch: process.env.BRANCH!,
    environment: process.env.ENVIRONMENT as Environment,
    registrationsClosed: process.env.NEXT_PUBLIC_REGISTRATIONS_CLOSED === "true",
    demoSongId: process.env.DEMO_SONG_ID!,

    posthogKey: process.env.NEXT_PUBLIC_POSTHOG_KEY!,
    posthogHost: process.env.NEXT_PUBLIC_POSTHOG_HOST!,
    posthogEnabled: process.env.NEXT_PUBLIC_POSTHOG_ENABLED === "true"
  };
};

export const config = getConfig();

// TODO-0: when on a 404, e.g. signIn, /image-bitmap-data-url-worker-IJpC7g_b.js.map also 404s - what is?
